var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcViewAllArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "28px",
    viewBox: "0 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_view_all_arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winds-Webapp-Copy",
    transform: "translate(-1635.000000, -1653.000000)",
    fill: "#7D70FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy-8",
    transform: "translate(1506.000000, 1648.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.964752,5.54108491 L160.445772,17.4935477 C160.766626,17.8440951 160.959702,18.299493 160.994355,18.7796677 L160.999863,18.9607382 C161.005975,19.5064957 160.806732,20.0335628 160.445772,20.4279287 L148.991556,32.3803915 C148.214242,33.2008967 146.948203,33.2074383 146.163741,32.3944092 C145.379279,31.5813801 145.373025,30.2571706 146.150339,29.4366653 L154.229,21.015 L131.184,21.016 C129.97781,21.016 129,20.0381899 129,18.832 C129,17.6258101 129.97781,16.648 131.184,16.648 L153.982,16.647 L146.150339,8.48481108 C145.41055,7.63253226 145.472199,6.31486436 146.287039,5.54108491 C147.046484,4.81963836 148.205307,4.81963836 148.964752,5.54108491 Z",
    id: "ic_view_all_arrow"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewAllArrow);
export default __webpack_public_path__ + "static/media/ic_view_all_arrow.abde3acf89803b629aba4070b9b0f23b.svg";
export { ForwardRef as ReactComponent };